import { generateSeperatorTags } from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/utils';

export default class ShopScoreItemModel {
  originalData: any = null;

  textName = undefined;
  icon = undefined;
  constructor(data) {
    this.originalData = data;
    this.textName = this.originalData?.shopScoreInfo?.score;
    this.icon = this.originalData?.shopScoreInfo?.icon;
  }

  paramsForLxLog = () => ({
    shop_rating: this.originalData?.shopScoreInfo?.score || '-999',
  })
}
